import { render } from "./CollectImportMessage.vue?vue&type=template&id=4554abc3"
import script from "./CollectImportMessage.vue?vue&type=script&lang=js"
export * from "./CollectImportMessage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__